// extracted by mini-css-extract-plugin
export default {"root":"TextEditor_root__Lttbk","textarea":"TextEditor_textarea__0PCiq","dropdown":"TextEditor_dropdown__HDLQK"};